<template>
  <div class="form-group row">
    <label for="staffLead" class="col-lg-4 label-text">
      Staff Lead
    </label>
    <div class="loading col-lg-5" v-if="loadingUsers">
      Loading...
    </div>
    <div class="col-lg-8" v-if="!loadingUsers">
      <select v-if="activeUsers && activeUsers.length"
        class="form-control"
        name="staffLead"
        v-model="localStaffLeadSelected"
        @change="changeStaffLeadSelected"
      >
        <option v-for="option in activeUsers"
          :key="option.id"
          :value="option"
        >
          {{ option.name }}{{ option.inactive ? ' (Inactive)' : ''}}
        </option>
      </select>
      <small
        v-if="systemSetStaffLead && showSystemDefaultWarning"
        class="form-text text-muted alert-danger">
        {{warningMessage}}
      </small>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'StaffLeadAssignment',
  data() {
    return {
      localStaffLeadName: this.staffLeadName,
      localStaffLeadSelected: null,
      systemSetStaffLead: false,
      staffLeadNone: {
        id: '0',
        name: 'None',
        notAssigned: false,
      },
      warningMessage: 'Warning: Staff Lead was not found and has automatically changed. Please select the correct Staff Lead from the dropdown.',
    };
  },
  props: {
    staffLead: String,
    staffLeadName: String,
    showSystemDefaultWarning: Boolean,
  },
  mounted() {
    this.$store.dispatch('User/fetchActiveUsers')
      .then(() => this.calculateInitialLocalStaffLeadSelected());
  },
  computed: {
    ...mapState('User', {
      activeUsers: state => state.activeUsers,
      loadingUsers: state => state.loading,
      user: state => state.user,
    }),
    ...mapGetters('User', {
      getCurrentUserFromActiveUsers: 'getCurrentUserFromActiveUsers',
    }),
  },
  methods: {
    changeStaffLeadSelected() {
      this.systemSetStaffLead = false;
      this.$emit('update-staff-lead-selected', this.localStaffLeadSelected);
    },
    calculateInitialLocalStaffLeadSelected() {
      if (!this.staffLead || this.staffLead === '0') {
        // creating new record
        this.localStaffLeadSelected = this.getCurrentUserFromActiveUsers;
        this.systemSetStaffLead = true;
        // make sure the parent component updates w/ the pre-selected staffLead
        this.$emit('update-staff-lead-selected', this.localStaffLeadSelected);
      } else {
        // editing existing record
        const staffLeadUser = this.activeUsers
          .find(u => u.id === this.staffLead);
        if (staffLeadUser) {
          this.localStaffLeadSelected = staffLeadUser;
          this.systemSetStaffLead = false;
        } else {
          this.localStaffLeadSelected = this.getCurrentUserFromActiveUsers;
          this.systemSetStaffLead = true;
          // make sure the parent component updates w/ the pre-selected staffLead
          this.$emit('update-staff-lead-selected', this.localStaffLeadSelected);
        }
      }
    },
  },
};
</script>
